<div class="fx-column">
  <span class="label" *ngIf="label">{{label}}</span>
  <mat-checkbox color="primary" [(ngModel)]="value" (ngModelChange)="onChange()">
    <span class="text" *ngIf="valueLabel">{{valueLabel | translate}}</span>
  </mat-checkbox>
</div>